import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import {
  FlexCol,
  FlexRowCenterVertical,
  FlexRow,
  FlexColCenterHorizontal,
} from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { ProductPriceCartMobile } from './ProductPriceCartMobile';
import { StockInfo } from './StockInfo';
import { getProductDefaultInfo } from './ProductTabRowTable';

export interface Props {
  product: any;
  addToCart: any;
  addToRequest: any;
  rowsData: string[];
  isB2B: boolean;
}

function ProductTabRowMobile({
  product,
  addToRequest,
  addToCart,
  rowsData,
  isB2B,
}: Props) {
  const [count, setCount] = React.useState(1);

  const handleCountChange = newVal => {
    setCount(newVal);
  };

  const {
    onStock,
    name,
    price,
    unit,
    availability,
    mocPrice,
    priceWithoutVat,
  } = getProductDefaultInfo(product);

  const handleAddToCart = () => {
    addToCart(product, count);
  };

  const handleAddToRequest = () => {
    addToRequest(product, count);
  };

  const renderName = () => {
    return (
      <ImageNameWrapper>
        <NameInputWrapper>
          <Name>{name}</Name>
        </NameInputWrapper>
      </ImageNameWrapper>
    );
  };

  const renderStock = () => {
    return (
      <StyledStockInfo
        colorMapTable={{
          '1': 'rgb(45, 204, 141)',
          '4': 'rgb(255, 45, 88)',
          '2': 'rgb(78,79,255)',
        }}
        availability={availability}
        onStock={onStock}
        unit={unit}
        withoutInfo={true}
        withoutExactStockCount={true}
      />
    );
  };

  const renderPrice = () => {
    return <Price>{`${price} € / ${unit}`}</Price>;
  };

  const renderMocPrice = () => {
    return <MocPrice>{`MOC: ${mocPrice} € / ${unit}`}</MocPrice>;
  };

  const renderCart = () => {
    return (
      <ProductPriceCartMobile
        unit={unit}
        addToCart={handleAddToCart}
        addToRequest={handleAddToRequest}
        count={count}
        handleCountChange={handleCountChange}
      />
    );
  };

  return (
    <AllWrapper>
      <Wrapper>
        <LeftWrapper>
          {rowsData.includes('name') ? renderName() : null}
          {rowsData.includes('stock') ? renderStock() : null}
        </LeftWrapper>
        <RightWrapper>
          {rowsData.includes('price') ? renderPrice() : null}
          {rowsData.includes('mocprice') ? renderMocPrice() : null}
        </RightWrapper>
      </Wrapper>
      {rowsData.includes('cart') ? renderCart() : null}
    </AllWrapper>
  );
}

const AllWrapper = styled(FlexCol)`
  width: 100%;
  margin: 0;
  padding: ${rem(24)} 0;
  border-radius: ${rem(2)};
  border-top: ${({ theme }) => theme.borders.primary};
  background-color: ${({ theme }) => theme.colors.contentBackground};
  justify-content: space-between;
  align-items: stretch;

  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }

  ${({ theme }) => theme.mediab.l925`
    max-width: initial;
  `}

  ${({ theme }) => theme.mediab.m760`
    margin: 0 auto;
    max-width: initial;
    width: 100%;
    &:last-child {
      margin: 0 auto;
    }
  `}
`;

const Wrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  margin: 0;
  border-radius: ${rem(2)};
  justify-content: space-between;
  align-items: stretch;
  margin-bottom: ${rem(16)};

  &:last-child {
  }

  ${({ theme }) => theme.mediab.l925`
    max-width: initial;
  `}

  ${({ theme }) => theme.mediab.m760`
    margin: 0 auto;
    margin-bottom: ${rem(16)};
    max-width: initial;
    width: 100%;
    &:last-child {
      margin: 0 auto;
    }
  `}
`;

const Price = styled.span`
  font-family: ${({ theme }) => theme.font.tertiary};
  font-size: ${rem(12)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  white-space: nowrap;
`;

const MocPrice = styled(Price)``;

const StyledStockInfo = styled(StockInfo)`
  margin: 0;
`;

const ImageNameWrapper = styled(FlexRow)`
  margin-bottom: ${rem(8)};
`;

const LeftWrapper = styled(FlexCol)`
  justify-content: space-between;
`;

const RightWrapper = styled(FlexCol)`
  justify-content: space-between;
  align-items: flex-end;
`;

const NameInputWrapper = styled(FlexCol)`
  margin-right: ${rem(32)};

  ${({ theme }) => theme.mediab.s450`
     margin-right: ${rem(0)};
  `}
`;

const Name = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-bottom: ${rem(12)};
  color: ${({ theme }) => theme.colors.black};
  text-align: left;
  font-family: ${({ theme }) => theme.font.secondary};
  font-weight: 300;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  ${({ theme }) => theme.mediab.m810`
      margin-bottom: ${rem(8)};
  `}
`;

export { ProductTabRowMobile };
